import { render, staticRenderFns } from "./VeranstaltungSelectModal.vue?vue&type=template&id=4a654175&"
import script from "./VeranstaltungSelectModal.vue?vue&type=script&lang=js&"
export * from "./VeranstaltungSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports